import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { useTranslationContext } from '../../Shared/hooks/useTranslationContextHook'
import doxExplorerCDMServices from '../../Shared/services/doxExplorerCDMServices'
import { DoxFileOperationStatus } from '../services/doxExplorerConsts'

const DoxExplorerFilesTableFileCell = (props) => {
    const translateString = useTranslationContext();
    const handleOpen = () => {
        props.onSelectItem(props.documentId)
    }

    return (
        <Fragment>
            <div className={classnames('doxe-files-table-cell name hrb-column', `hrb-is-${props.width}`)} 
                style={{ flexDirection: 'column', justifyContent: props.justifyContent }}
                onClick={handleOpen}>
                {props.errorKey !== DoxFileOperationStatus.FAIL_NO_SUCH_FILE &&
                    <div className='dox-link'>
                        <span>{doxExplorerCDMServices.getTruncatedFileName(props.fileName, props.fileType, false)}</span>
                    </div>
                }
                {props.errorKey &&
                    <div className='doxe-red'>
                        <b>{translateString(props.errorKey)}</b>
                    </div>
                }
            </div>
        </Fragment>
    )
}

DoxExplorerFilesTableFileCell.propTypes = {    
    documentId: PropTypes.string.isRequired,
    fileType: PropTypes.string.isRequired,
    fileName: PropTypes.string.isRequired,
    onSelectItem: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    errorStatus: PropTypes.string,
    justifyContent: PropTypes.string,
    isSoftDeleted: PropTypes.bool
}   

export default DoxExplorerFilesTableFileCell;